import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from './notification.service';
import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './common-request-response.service';
import { PartnerDetail } from '../models/partner-detail';
import { WebService } from './web.service';


@Injectable({
  providedIn: 'root'
})
export class PartnerDetailService {

  private partnerDetail: PartnerDetail;
  private subject: Subject<PartnerDetail> = new Subject<PartnerDetail>();

  constructor(
    private notificationService: NotificationService,
    private _commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private webService: WebService
  ) { }

  setPartnerDetail(partnerUrlJson): boolean {
    let connectionEstablished;

    this.webService.post('shared/partner/details', partnerUrlJson)
      .subscribe(
        (partnerData: PartnerDetail) => {
          this.partnerDetail = partnerData;
          this._commonService.setDataWithoutObservable(partnerData.partnerId, 'partnerId')
          connectionEstablished = true;
          this._commonDataSharedService.partnerDetailData.next(partnerData);
          this.subject.next(this.partnerDetail);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching partner detail');
          connectionEstablished = false;
        });

    return connectionEstablished;
  }

  getPartnerList() {
    const pageJson = {
      page: 1,
      pageSize: 100,
    };
    return this._commonRequestResponseService.postWithHeader('admin/partners', pageJson);
  }

  switchSelectedPartner(newPartnerId) {
    this._commonDataSharedService.partnerId.next(newPartnerId);

    if (newPartnerId) {
      this._commonDataSharedService.partnerChange.next(newPartnerId);
    }
  }
}
